import { Link } from "@tanstack/react-router";
import { Phone, Instagram, ExternalLink } from "lucide-react";
import { formatPhone } from "@/lib/format";
import { useStoreSettings, instagramHandle, displayDomain } from "@/lib/settings.functions";

export function SiteFooter() {
  const settings = useStoreSettings();

  return (
    <footer className="bg-eg-dark text-slate-300 mt-16">
      <div className="mx-auto max-w-7xl px-4 py-10 grid gap-6 sm:grid-cols-3">
        <div>
          <h2 className="font-display text-lg font-bold text-eg-gold">{settings.nome_fantasia}</h2>
          <p className="mt-2 text-sm">
            {settings.cidade} / {settings.uf}
          </p>
          <p className="text-sm">{settings.descricao}</p>
        </div>
        <div>
          <h2 className="font-display text-sm font-semibold text-white uppercase tracking-wide">
            Contato
          </h2>
          <a
            href={`https://wa.me/${settings.whatsapp_number}`}
            className="mt-2 flex items-center gap-2 text-sm hover:text-eg-gold"
          >
            <Phone className="h-4 w-4" /> {formatPhone(settings.whatsapp_number.slice(-11))}
          </a>
          <a
            href={settings.instagram_url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 flex items-center gap-2 text-sm hover:text-eg-gold"
          >
            <Instagram className="h-4 w-4" /> {instagramHandle(settings.instagram_url)}
          </a>
        </div>
        <div>
          <h2 className="font-display text-sm font-semibold text-white uppercase tracking-wide">
            Institucional
          </h2>
          <a
            href={settings.institutional_url}
            className="mt-2 flex items-center gap-2 text-sm hover:text-eg-gold"
          >
            <ExternalLink className="h-4 w-4" /> {displayDomain(settings.institutional_url)}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-slate-400">
        <div className="mb-2 flex flex-wrap justify-center gap-x-4 gap-y-1">
          <Link to="/termos" className="hover:text-eg-gold">
            Termos de Uso
          </Link>
          <Link to="/privacidade" className="hover:text-eg-gold">
            Política de Privacidade
          </Link>
          <Link to="/trocas-devolucoes" className="hover:text-eg-gold">
            Trocas e Devoluções
          </Link>
        </div>
        © {new Date().getFullYear()} {settings.nome_fantasia}. Todos os direitos reservados.
      </div>
    </footer>
  );
}
